exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plan-inactive[data-v-059ef8dc]{border:4px solid #d03333}.btn-change-active[data-v-059ef8dc]{cursor:pointer}.btn-change-active[data-v-059ef8dc]:hover{opacity:.8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-059ef8dc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/system/plans/index.vue
// module id = opvs
// module chunks = 0